module.exports = __webpack_public_path__ + "media/images/add-novo-af6d49cb41dfb19d5307f38405e2cbdf.svg";